<!--suppress AngularUndefinedBinding -->
<div class="form">
  <div class="form-container outer">
    <div class="form-form">
      <div class="form-form-wrap">
        <div class="form-container">
          <div [hidden]="loading" class="form-content">
            <h1 translate>Recover Password</h1>
            <div *ngIf="serverMsg" class="d-flex text-danger bg-danger-20 border border-danger rounded p-3 my-3">
              <div class='mx-auto' translate>{{serverMsg}}</div>
            </div>
            <div *ngIf="serverInfo" class="d-flex text-success bg-success-20 border border-success rounded p-3 my-3">
              <div class='mx-auto' translate>{{serverInfo}}</div>
            </div>
            <form [formGroup]="recoverForm" *ngIf="currentStep == 'mobile'" class="text-left" novalidate>
              <div class="form">
                <div class="field-wrapper input">
                  <label for="mobile" translate>Username</label>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  <input [ngClass]="{'is-invalid': submitted && rf.mobile.errors}" formControlName="mobile" id="mobile" name="mobile" type="text" class="form-control" [placeholder]="(isSubAccount? 'Enter Gov Id / Mobile' : 'Enter your mobile number') | translate">
                  <div *ngIf="submitted && !isSubAccount && rf.mobile.errors" class="invalid-feedback" translate>Please enter a valid username</div>
                  <div *ngIf="submitted && isSubAccount && rf.mobile.errors.required" class="invalid-feedback" translate>Please enter a valid gov id</div>
                </div>
                <div class="my-1 mb-3">
                  <a *ngIf="!isSubAccount" (click)="toggleSubAccount()" translate class="forgot-pass-link">Sub Account?</a>
                  <a [hidden]="!isSubAccount" (click)="toggleSubAccount()" class="forgot-pass-link">{{'Main Account?' | translate}}</a>
                </div>
                <div class="d-sm-flex justify-content-between">
                  <div class="field-wrapper">
                    <button type="submit" [hidden]="isSubAccount" (click)="sendMobile($event)" class="btn btn-primary" translate>Submit</button>
                    <button type="submit" [hidden]="!isSubAccount" (click)="sendMobile($event)" class="btn btn-primary" translate>Submit Sub Account</button>
                  </div>
                </div>
              </div>
            </form>
            <form [formGroup]="otpForm" *ngIf="currentStep == 'otp'" class="text-left" novalidate>
              <div class="form">
                <div class="field-wrapper input">
                  <label for="mobile" translate>Username</label>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  <input disabled="disabled" [ngClass]="{'is-invalid': submitted && rf.mobile.errors}" formControlName="mobile" id="mobile" name="mobile" type="text" class="form-control" [placeholder]="(isSubAccount? 'Enter Gov Id / Mobile' : 'Enter your mobile number') | translate">
                </div>
                <div id="otp-field" class="field-wrapper input">
                  <div class="d-flex justify-content-between">
                    <label for="otp" translate>OTP</label>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                  <input #otp [ngClass]="{'is-invalid' : submitted && of.otp.errors}" formControlName="otp" id="otp" name="otp" type="text" class="form-control" [placeholder]="'OTP' | translate">
                  <div *ngIf="submitted && of.otp.errors" class="invalid-feedback" translate>
                    Please enter a valid otp
                  </div>
                  <svg (click)="toggleOtp()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id="toggle-password" class="feather feather-eye">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </div>
                <div id="password-field" class="field-wrapper input">
                  <div class="d-flex justify-content-between">
                    <label for="password" translate>Password</label>
                    <!--                    <a routerLink='/auth/recover-password' translate class="forgot-pass-link">Forgot Password?</a>-->
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                  <input #password [ngClass]="{'is-invalid' : submitted && of.password.errors}" formControlName="password" id="password" name="password" type="password" class="form-control" [placeholder]="'New Password' | translate">
                  <div *ngIf="submitted && of.password.errors" class="invalid-feedback" translate>
                    Please enter a valid new password
                  </div>
                  <svg (click)="togglePassword()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id="toggle-password" class="feather feather-eye">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </div>
                <div class="d-sm-flex justify-content-between">
                  <div class="field-wrapper">
                    <button type="submit" [hidden]="isSubAccount" (click)="submitOtp($event)" class="btn btn-primary" translate>Submit</button>
                    <button type="submit" [hidden]="!isSubAccount" (click)="submitOtp($event)" class="btn btn-primary" translate>Submit Sub Account</button>
                  </div>
                </div>
              </div>
            </form>
            <div class="my-3">
              <a class="mx-auto" routerLink="/" translate>Back to login page</a>
            </div>
          </div>
          <div [hidden]="!loading" class="form-content">
            <div class="d-flex">
              <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
